import {EventEmitter, Injectable, Output} from '@angular/core';
interface Toast {
  id: string;
  delay: number;
}

@Injectable()
export class ToastService {
  @Output() toggleToast: EventEmitter<any> = new EventEmitter();
  constructor() { }

  toast(event) {
    this.toggleToast.emit(event);
  }
}
